import API from 'api/API';
import { useState, useEffect } from 'react';
import { useLanguage } from 'context/AppContext';

interface UseDraftList {
  draftSets: string[];
  draftDevices: string[];
  loading: boolean;
}

const useDraftList = (): UseDraftList => {
  const [draftSets, setDraftSets] = useState<string[]>([]);
  const [draftDevices, setDraftDevices] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const [
    {
      DraftActions: { draftError },
    },
  ] = useLanguage();

  useEffect(() => {
    (async () => {
      try {
        const [_draftSets, _draftDevices] = await Promise.all([API.set.list(), API.device.list()]);
        setDraftSets(_draftSets);
        setDraftDevices(_draftDevices);
      } catch (error) {
        API.errorHandler(error, draftError);
      }
      setLoading(false);
    })();
  }, [draftError]);

  return { draftSets, draftDevices, loading };
};

export default useDraftList;
